/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Box, Grid } from "@chakra-ui/react";
import { BsCartX, BsArrowRight, BsArrowLeft } from "react-icons/bs";
import {
  DeleteCart,
  decrementQuantity,
  fetchProducts,
  incrementQuantity,
} from "../../actions";
import { createOrder } from "../../Redux/ProductController/action";
import CartItem from "./CartItem";
import { useParams } from "react-router-dom";
import callApi from "../../api";

import { BASE_URL_FLORAHUB } from "../../Redux/App/action";
import CustomButton from "../customButton/CustomButton";

const CartItems = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const { orderList } = useSelector((store) => store.prodReducer);
  const [cartData, setCartData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [originalPrice, setOriginalPrice] = useState(0);
  const myState = useSelector((state) => state.ProductCart);
  const productId = +params._id;

  useEffect(() => {
    dispatch(fetchProducts());
  }, []);

  useEffect(() => {
    if (cartData.length > 0) {
      let total = 0;
      cartData.forEach((item) => {
        total =
          total + item.quantity * item.productDetail.priceDetails.sellingPrice;
      });
      setGrandTotal(total);
    }
  }, [cartData]);

  useEffect(() => {
    if (cartData.length > 0) {
      let total = 0;
      cartData.forEach((item) => {
        total = total + item.quantity * item.productDetail.priceDetails.price;
      });
      setOriginalPrice(total);
    }
  }, [cartData]);

  useEffect(() => {
    const productDetailsWithQuantity = myState.products.map((item) => ({
      productDetail: item.productDetail,
      quantity: item.quantity,
    }));
    setCartData(productDetailsWithQuantity);
  }, [myState.products]);

  const deleteProduct = async (data) => {
    try {
      await callApi(
        `${BASE_URL_FLORAHUB}/inventory/api/v1/cart`,
        "PUT",
        {
          productId: data.productId,
          variantId: data.variantId,
          quantityType: data.quantityType,
        },
        null
      );
      dispatch(DeleteCart(data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const updateProductQuantity = async (data) => {
    try {
      setIsLoading(true);
      const res = await callApi(
        `${BASE_URL_FLORAHUB}/inventory/api/v1/cart`,
        "PUT",
        {
          productId: data.productId,
          variantId: data.variantId,
          quantityType: data.quantityType,
        },
        null
      );

      if (res.status === 200) {
        if (data.quantityType === "ADD") {
          dispatch(incrementQuantity(data));
          dispatch(fetchProducts());
        } else {
          dispatch(decrementQuantity(data));
          dispatch(fetchProducts());
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const handleQuantityIncrease = (data) => {
    updateProductQuantity(data);
  };

  const handleQuantityDecrease = (data) => {
    updateProductQuantity(data);
  };

  const handleDeleteCartItem = (data) => {
    deleteProduct(data);
  };

  const handleProceedToCheckout = () => {
    if (myState.products) {
      if (myState.products.length > 0) {
        const orderData = {
          orderType: "CART",
        };
        dispatch(createOrder(orderData));
        if (orderList?.find((item) => item.productId === productId)) {
          orderList.push(orderData);
        }
        navigate("/Cart/PlaceOrder");
      }
    }
  };

  // if (myState?.loading) {
  //   return (
  //     <Box
  //       position="fixed"
  //       top="0"
  //       left="0"
  //       width="100%"
  //       height="100%"
  //       display="flex"
  //       alignItems="center"
  //       justifyContent="center"
  //       background="rgba(0, 0, 0, 0.5)"
  //       zIndex="9999"
  //     >
  //       <Spinner size="xl" color="blue.500" thickness="4px" />
  //     </Box>
  //   );
  // }

  return (
    <Box height={"100%"} width={"95%"} margin={"auto"} mt={"20"} mb={"20"}>
      <p className="text-[#3c375f] text-xl font-bold text-left pt-3 mb-3">
        My Cart ({cartData?.length})
      </p>
      <Grid
        // templateColumns={{ base: "1fr", md: "70% 30%" }}
        templateColumns={{
          base: "1fr",
          md: `${cartData.length === 0 ? "100%" : "70% 30%"}`,
        }}
        gap={3}
        width="100%"
      >
        <Box className="bg-white rounded-md p-3">
          {myState.loading && !localStorage.getItem("products") && (
            <div className="flex justify-center items-center h-[80vh]">
              Loading...
            </div>
          )}
          {cartData &&
            cartData.map((el) => {
              return (
                <CartItem
                  key={el.productDetail.productId}
                  cartData={el.productDetail}
                  productQuantity={el.quantity}
                  handleQuantityDecrease={handleQuantityDecrease}
                  handleQuantityIncrease={handleQuantityIncrease}
                  handleDeleteCartItem={handleDeleteCartItem}
                  isLoading={isLoading}
                />
              );
            })}
          {cartData && cartData.length > 0 && (
            <div className="flex justify-start mt-2">
              <CustomButton
                size="small"
                iconLeft={<BsArrowLeft className="inline" size={20} />}
                onClick={() => navigate("/")}
                className="font-normal"
              >
                Back To Shop
              </CustomButton>
            </div>
          )}
          {cartData?.length === 0 && (
            <div className="my-8 flex flex-col justify-center text-center  justify-items-center ">
              <div className="mx-auto">
                <BsCartX size={60} color="#3c375f" />
              </div>
              <div className="mt-2 mb-1 text-bas ">
                <p className="font-medium">
                  Your Cart Awaits Your Favorite Items !
                </p>
              </div>

              <div className="mb-3">
                {/* <CustomButton
                  className="mx-auto"
                  onClick={() => navigate("/potsAll")}
                  iconRight={<BsArrowRight size={20} className="inline" />}
                >
                  Let's Fill Your Cart with!
                </CustomButton> */}
                Let's Fill Your Cart with{" "}
                <BsArrowRight size={20} className="inline" />
              </div>

              <div>
                <button
                  className="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800"
                  onClick={() => {
                    navigate("/homeDecorAll");
                  }}
                >
                  <span className="relative px-3 py-1.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                    Home Decor
                  </span>
                </button>
                <button
                  className="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-cyan-200 dark:focus:ring-cyan-800"
                  onClick={() => {
                    navigate("/potsAll");
                  }}
                >
                  <span className="relative px-3 py-1.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                    Pots
                  </span>
                </button>
                <button
                  className="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800"
                  onClick={() => {
                    navigate("/plantEcommerce");
                  }}
                >
                  <span className="relative px-3 py-1.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                    Plants
                  </span>
                </button>
              </div>
            </div>
          )}
        </Box>

        {cartData && cartData.length > 0 ? (
          <Box
            className="bg-white border border-gray-200 rounded-lg shadow p-4 pl-3 max-h-56"
            order={{ base: -1, md: "initial" }}
          >
            <h4 className="my-2 text-xl text-left font-bold tracking-tight text-gray-900 dark:text-white">
              Subtotal
            </h4>

            <div className="flex justify-between items-center ">
              <p className="font-semibold">Original Price</p>
              <p>₹ {originalPrice}</p>
            </div>
            <div className="flex justify-between items-center ">
              <p className="font-semibold">Discounted Price</p>
              <p>₹ {grandTotal}</p>
            </div>
            {/* <div className="flex justify-between items-center ">
              <p className="font-semibold">Delivery Charge</p>
              <p className="text-semibold">FREE</p>
            </div> */}

            <hr className="my-3" />

            <div className="flex justify-between items-center ">
              <p className="font-semibold text-sm">Total</p>
              <p className="text-bold">₹ {grandTotal}</p>
            </div>

            {/* <div class="flex items-center">
              <input id="link-checkbox" type="checkbox" value="" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" />
              <label for="link-checkbox" className="ms-2 text-sm font-medium text-gray-900 ">Gift Wrap</label>
            </div> */}

            <div className="flex  mt-3">
              <CustomButton
                className=" mx-auto w-1/2 !bg-[#372449] font-normal w-100"
                onClick={() => {
                  handleProceedToCheckout();
                }}
              >
                Proceed To Buy
              </CustomButton>
            </div>
          </Box>
        ) : null}
      </Grid>
    </Box>
  );
};

export default CartItems;
